var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoporte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.1096C20 6.69134 16.4183 3.10962 12 3.10962C7.58172 3.10962 4 6.69134 4 11.1096",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.5481V13.6712C2 12.7534 2.62459 11.9535 3.51493 11.7309L5.25448 11.296C5.63317 11.2013 6 11.4877 6 11.8781V17.3412C6 17.7315 5.63317 18.0179 5.25448 17.9232L3.51493 17.4884C2.62459 17.2658 2 16.4658 2 15.5481Z",
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15.5481V13.6712C22 12.7534 21.3754 11.9535 20.4851 11.7309L18.7455 11.296C18.3668 11.2013 18 11.4877 18 11.8781V17.3412C18 17.7315 18.3668 18.0179 18.7455 17.9232L20.4851 17.4884C21.3754 17.2658 22 16.4658 22 15.5481Z",
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.1096V18.6096C20 19.7142 19.1046 20.6096 18 20.6096H14.5",
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22.1096H10.5C9.67157 22.1096 9 21.438 9 20.6096C9 19.7812 9.67157 19.1096 10.5 19.1096H13.5C14.3284 19.1096 15 19.7812 15 20.6096C15 21.438 14.3284 22.1096 13.5 22.1096Z",
    stroke: "#01295F",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoporte);
export default __webpack_public_path__ + "static/media/soporte.f4e67df3f77bbc4d6bf85ff34fe82246.svg";
export { ForwardRef as ReactComponent };